import { cn } from "@/lib/utils";

import { MarketingLink } from "./MarketingButton";
import { productIcons } from "./productIcons";
import { MARKETING_PRODUCTS, type MarketingProductKey } from "./products";

const TINTS = [
  "bg-[linear-gradient(145deg,#fff,#eef0ff)]",
  "bg-[linear-gradient(145deg,#fff,#fff0f7)]",
  "bg-[linear-gradient(145deg,#fff,#f4ffe4)]",
];

export function Trademark({ className }: { className?: string }) {
  return (
    <sup
      className={cn(
        "ml-[3px] align-top font-figtree text-[9px] font-extrabold leading-none",
        className,
      )}
    >
      TM
    </sup>
  );
}

function ToolCard({
  productKey,
  index,
}: {
  productKey: MarketingProductKey;
  index: number;
}) {
  const product = MARKETING_PRODUCTS[productKey];
  return (
    <MarketingLink
      to={product.path}
      className={cn(
        "group relative flex min-h-[218px] flex-col rounded-[24px] border border-marketing-line px-[22px] pb-12 pt-[22px] shadow-[0_10px_34px_rgba(15,26,75,0.06)] outline-none transition-[transform,border-color,box-shadow] duration-200 hover:border-[rgba(48,66,226,0.5)] hover:shadow-[0_18px_42px_rgba(15,26,75,0.14)] focus-visible:border-[rgba(48,66,226,0.5)] focus-visible:shadow-[0_18px_42px_rgba(15,26,75,0.14)] motion-safe:hover:-translate-y-1 motion-safe:focus-visible:-translate-y-1",
        TINTS[index % 3],
      )}
    >
      <div className="flex items-center justify-between gap-[18px]">
        <h3 className="m-0 font-open-sans text-[21px] font-bold leading-[1.15] text-marketing-ink">
          {product.cardName}
          {product.trademark && <Trademark />}
        </h3>
        <div className="grid size-[38px] shrink-0 place-items-center rounded-[11px] bg-marketing-lavender text-marketing-purple [&_svg]:size-[21px]">
          {productIcons[product.icon]}
        </div>
      </div>
      <p className="mt-4 font-open-sans text-[15px] leading-[1.5] text-marketing-muted">
        {product.cardLede.map((line, i) => (
          <span key={i} className="block">
            {line}
          </span>
        ))}
      </p>
      <span className="absolute bottom-[17px] left-[22px] translate-y-[5px] font-open-sans text-[16px] font-extrabold text-blue-600 opacity-0 transition-[opacity,transform] duration-200 group-hover:translate-y-0 group-hover:opacity-100 group-focus-visible:translate-y-0 group-focus-visible:opacity-100 [@media(hover:none)]:translate-y-0 [@media(hover:none)]:opacity-100">
        Learn more →
      </span>
    </MarketingLink>
  );
}

export function ToolCardGrid({
  products,
  className,
}: {
  products: MarketingProductKey[];
  className?: string;
}) {
  return (
    <div
      className={cn(
        "grid grid-cols-3 gap-[18px] max-[980px]:grid-cols-2 max-[680px]:grid-cols-1",
        className,
      )}
    >
      {products.map((key, i) => (
        <ToolCard key={key} productKey={key} index={i} />
      ))}
    </div>
  );
}
